import { SearchInput } from 'root/widgets/common-components/search-input';

import { SearchBarProps } from 'root/widgets/mrt-search-modal/types';

const SearchBar = ({
  searchQuery,
  searchPlaceholder,
  onDebounceSearchChange,
  onClearQuery,
  onQueryChange,
}: SearchBarProps) => (
  <div className="search-bar">
    <SearchInput.Editable
      placeholder={searchPlaceholder}
      value={searchQuery}
      onChange={onQueryChange}
      debounceOptions={{
        callback: onDebounceSearchChange,
        delay: 200,
        shouldUpdateState: true,
      }}
    />
    {searchQuery.length > 0 && <i className="pgicon-cancel-circled clear-query-icon" onClick={onClearQuery} />}
  </div>
);

SearchBar.displayName = 'SearchBar';

export default SearchBar;
